import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.js';
import { initAnalytics, installGlobalErrorHandlers } from './utils/analytics.js';
import { initSentry } from './utils/sentry.js';

initSentry();
initAnalytics();
installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
